module.exports = __webpack_public_path__ + "html/video-player_29fcaf7fefd3cb675bc5241d182a8e6d.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/video-player.html
// module id = Tcr8
// module chunks = 27